<template>
  <div>
    <div class="title-lable-error">
      <span class="ml-3"
        >Your account is not eligible to perform this function</span
      >
    </div>
    <div
      class="d-flex flex-row mt-3 ml-3"
      style="color: #757575; font-size: 0.85rem"
    >
      <div>Please make your first deposit to continue.</div>
      <el-link
        :href="routeUrl.RECHARGE"
        class="ml-1"
        :underline="false"
        type="primary"
        target="_blank"
        >Recharge now</el-link
      >
    </div>
  </div>
</template>

<script>
import base from "@/scripts/base";

export default {
  extends: base,
};
</script>